<template>
  <div>
    <v-btn
      v-if="detailType == 'payment'"
      small
      color="primary"
      dark
      @click="suppress"
      :disabled="selected.length == 0"
    >Suppress Selected</v-btn>
    <v-btn
      v-if="detailType == 'clawback'"
      small
      color="primary"
      dark
      @click="$emit('setClawback')"
      :disabled="selected.length == 0"
    >Apply Clawback</v-btn>
    <v-btn
      small
      color="primary"
      dark
      @click="removePerm"
      :disabled="selected.length == 0"
    >Delete Selected</v-btn>
    <v-btn
      small
      color="primary"
      dark
      v-if="selected.length == 1"
      @click="$emit('editSelected')"
    >Edit Selected</v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CommissionDetail",
  props: {
    selected: {
      type: Array,
      required: true
    },
    detailType: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("commissions", ["run"])
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest", "updateSummary"]),
    removePerm() {
      this.selected.forEach(function(element) {
        element.runId = 0;
      });
      this.suppress(
        `${
          this.detailType == "clawback" ? "Clawbacks" : "Payments"
        } deleted for good`
      );
    },
    suppress(message) {
      let vm = this;
      let query = {
        message: message || `${this.detailType} suppressed for this run.`,
        url: `Commissions/SuppressSummary/${vm.run.runId}`,
        method: "post",
        body: this.selected
      };
      this.CommissionsRequest(query)
        .then(() => {
          vm.$emit("paymentsSuppressed");
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped></style>
